import React, { useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { SessionContext } from '../../contexts/SessionContext';
import { APIContext } from '../../contexts/APIContext';

/**
 * Widget to display suggested responses chips after 1st response
 */
interface ResponseSuggestionsProps {
  handleUserAction: (message: string) => void;
}

const ResponseSuggestions: React.FC<ResponseSuggestionsProps> = (props) => {
  const { handleUserAction } = props;
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const username = isAuthenticated ? accounts[0].username : ' ';
  const { setIsPromptRetried, isPromptGenerating } = useContext(SessionContext);
  const { userDetails, batchType } = useContext(APIContext);

  const handleClick = (message: string) => {
    setIsPromptRetried(false);
    handleUserAction(message);
  };

  return (
    <div className="suggested-responses-container flex flex-col gap-y-[9px]">
      {userDetails?.ConfigurationDetails?.PredefinedPrompts?.map((suggestion: any, index: any) => (
        <button
          key={index}
          className={`suggestion-btn flex-shrink-0 bg-gamma-grey flex items-start justify-between gap-12 p-4 border-[1px] border-gamma-bg-purple-bottom hover:bg-gamma-grey-hover ${
            (isPromptGenerating || batchType === 'batch') && 'not-clickable'
          }`}
          onClick={() => handleClick(suggestion.PromptName)}
        >
          <p className="text-gamma-light-grey font-normal text-base text-left leading-[1.6] tracking-[-0.28px]">
            {suggestion.PromptName}
          </p>

          <img src="/icons/paperplane.svg" alt="Send suggested prompt" className="send-btn h-4 w-4" />
        </button>
      ))}
    </div>
  );
};

export default ResponseSuggestions;
